import { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit'
import { AccountList, AccountListItem } from '@repo/accounts-types'
import { ApiResponse, createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ApiResponse<AccountList>> = {
  payload: {
    data: {
      accounts: [],
    },
    links: null,
  },
  meta: { fetchState: 'initial' },
  error: false,
}

export interface AccountListRequestParams {
  currency?: string
  date?: string | null
  interventionType?: string
}

export const { actions: accountListDataActions, reducer: accountListDataReducer } =
  createOperationSlice<
    ApiResponse<AccountList> | null,
    SliceCaseReducers<GenericOperationState<ApiResponse<AccountList> | null>>,
    AccountListRequestParams
  >({
    name: '@accounts/list/data',
    initialState,
    reducers: {
      updateAlias: (
        state,
        action: PayloadAction<{
          alias: AccountListItem['alias']
          accountId: AccountListItem['id']
        }>,
      ) => {
        if (state.payload) {
          const account = state.payload.data.accounts.find(
            (acc) => acc.id === action.payload.accountId,
          )

          if (account) {
            account.alias = action.payload.alias
          }
        }
      },
    },
  })
